import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

Backdraft.app("Shared/SignalExpression", function(app) {
  app.model("NumberCompareTerminal", "ExpressionTerminal", {
    defaults: {
      relop: ">",
      value: 0
    },

    beforeSet: function(attributes) {
      if (attributes.relop === '==') {
        attributes = _.extend({}, attributes, { relop: '=' });
      }

      return (
        _.extend({}, attributes, {
          value: (parseInt(attributes.value) || this.defaults.value)
        })
      );
    },

    type: function() {
      return 'NumberCompare';
    },

    text: function() {
      return (
        [
          this.get('terminal'),
          this.get('relop'),
          this.get('value')
        ].join(" ")
      );
    }
  });
});
